module.exports = __webpack_public_path__ + "static/media/approveCardReplacementIcon.8f7570d1.svg";